import VerificationDetailsModal from './VerificationDetailsModal'

export default VerificationDetailsModal
